import React, { Fragment } from "react"

import OfflineOrderDetailsItem from "./OfflineOrderDetailsItem"
import classes from "./OfflineOrderDetailsItems.module.scss"

const OfflineOrderDetailsItems = props => {
  const { offlineOrder } = props

  return (
    <Fragment>
      {offlineOrder.order.items.map((orderItem, orderItemIndex) => (
        <div
          key={orderItemIndex}
          className={classes["item"]}
        >
          <OfflineOrderDetailsItem
            orderItem={orderItem}
          />
        </div>
      ))}

      {offlineOrder.order.combos.map((orderCombo, orderComboIndex) =>
        <div
          key={orderComboIndex}
          className={classes["combo"]}
        >
          <div className={classes["comboCode"]}>
            {orderCombo.name}
          </div>
          <div>
            {orderCombo.items.map((comboItem, ciIndex) =>
              <div
                key={ciIndex}
                className={classes["comboItem"]}
              >
                <OfflineOrderDetailsItem
                  orderItem={comboItem}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default OfflineOrderDetailsItems